import i18n from 'src/i18n';
import { Link } from 'react-router-dom';
import { Title, Text, ProgressText, ProgressBar } from './card.styles';
import { CardProps } from './card.types';

const Card = ({ href, title, text, progress, onClick }: CardProps) => {
  const isValidProgress = typeof progress === 'number';

  return (
    <Link
      to={href}
      title={title}
      className="_d-block _text-decoration-none _border _border-gray-300 _rounded-lg _p-4"
      onClick={onClick}
    >
      <Title className="_text-2 _font-weight-bold _text-gray-900 _mb-1">{title}</Title>
      {text && <Text className="_text-1 _text-gray-700 _mb-0">{text}</Text>}

      {isValidProgress && (
        <div className="_d-flex _flex-column _pt-3">
          <ProgressText className="_text-gray-700 _d-block _mb-2">
            {i18n.t('profile.interests.card.progress_text', { progress })}
          </ProgressText>

          <ProgressBar value={progress} max="100" className="_w-full" />
        </div>
      )}
    </Link>
  );
};

export default Card;
